<template>
  <input type="date" v-on:input="updateValue($event.target)" class="form-control" v-bind:value="dateToYYYYMMDD(value)"/>
</template>

<script>
export default {
  props: {
    value: {
      type: Date,
      default: new Date()
    }
  },
  methods: {
    dateToYYYYMMDD(d) {
      // alternative implementations in https://stackoverflow.com/q/23593052/1850609
      return d && new Date(d.getTime()-(d.getTimezoneOffset()*60*1000)).toISOString().split('T')[0];
    },
    updateValue: function (target) {
      this.$emit('input', target.valueAsDate);
    }
  }
}
</script>
